import React from 'react';
import { ISonURL } from '../../../../types/IUrl';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { ContentLink } from '../../../../_lib/components/ContentLink';
import { murmurhash } from '../../../../lib/js/hash';
import { HyperlinkTarget } from '../../../atoms/Hyperlink';
import { Namespace } from '../../../../translation/namespace';
import { TooltipPlacement } from '../../../atoms/Tooltip';

export function ExternalLinkListItem({ name, url }: ISonURL) {
  const { t } = useSonTranslation('phrases');
  return (
    <ContentLink
      id={murmurhash(url)}
      to={url}
      external
      newWindowIndicator
      target={HyperlinkTarget.BLANK}
      title={t(`${Namespace.phrases}:linkOpensInNewWindow`)}
      tooltipPlacement={TooltipPlacement.BOTTOM}
    >
      {name || url}
    </ContentLink>
  );
}
